<template>
    <div class="attr-content font-prop">
        <div class="line">
            <span class="mar-r5">字体:</span>
            <Select v-model="fontFamily" size="small" @on-change="changed" class="family">
                <Option v-for="(item, index) in fontList" :value="item" :key="index">{{ item }}</Option>
            </Select>
        </div>
        <div class="line">
            <span class="mar-r5">颜色:</span>
            <ColorPicker transfer v-model="color" @on-change="changed" size="small"/>
        </div>
        <div class="line">
            <span class="mar-r5">大小:</span>
            <InputNumber v-model="fontSize" @on-change="changed" size="small"></InputNumber>
        </div>
        <div class="line">
            <span class="mar-r5">斜体:</span>
            <RadioGroup v-model="fontStyle" @on-change="changed" size="small">
                <Radio label="正常"></Radio>
                <Radio label="斜体"></Radio>
            </RadioGroup>
        </div>
        <div class="line">
            <span class="mar-r5">粗体:</span>
            <RadioGroup v-model="fontWeight" @on-change="changed" size="small">
                <Radio label="正常"></Radio>
                <Radio label="粗体"></Radio>
            </RadioGroup>
        </div>
    </div>
</template>
<script>
export default {
    props:["value"],
    data() {
        return {
            fontStyle:"",
            fontSize:12,
            color: "#fff",
            fontWeight: 'normal',
            fontFamily: '',
            fontList: ['PingFang', 'AgencyFB-Reg', '宋体', '黑体']
        }
    },
    watch: {
        value:{
            handler(value){
                if(value){
                    this.fontFamily = value.fontFamily || 'PingFang';
                    this.fontStyle = value.fontStyle==='italic'?'斜体':'正常';
                    this.fontWeight = value.fontWeight==='bold'?'粗体':'正常';
                    this.fontSize = value.fontSize||12;
                    this.color = value.color||'#fff';
                }
            },
            immediate:true
        }
    },
    methods: {
        changed(){
            this.$emit("input",{
                fontFamily:this.fontFamily || 'PingFang',
                fontStyle:this.fontStyle==='斜体'?'italic':'normal',
                fontWeight: this.fontWeight==='粗体'?'bold':'normal',
                fontSize:this.fontSize,
                color:this.color
            });
            this.$emit('save');
        }
    }
}
</script>
<style lang="less">
.font-prop{
    .line{
        padding: 0 0 10px 0;
    }
    .family {
        width: 100px;
    }
}
</style>